export default {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:5000',
  facebookAppId: process.env.REACT_APP_FACEBOOK_APP_ID || '206426245015108',
  googleClientId:
    process.env.REACT_APP_GOOGLE_CLIEN_ID ||
    '833576451835-50hsivmjo43a8eqa0dfaeec6fr3v5hgk.apps.googleusercontent.com',
};
